export default __webpack_public_path__ + "static/media/ph01.7de2a1d9.png";